import { Button, Card, Space, Typography, useMessagedAsyncRetry } from "@payping/web-components";
import { LockOutlined, SafetyOutlined, UnlockOutlined } from "@payping/icons";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { accountApis } from "@payping/api";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";

const MobileLoginEnableDisable = () => {
  const { profile } = DashboardRoutes;
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const { loading: loadingIsTwoFAActive, value: isTwoFAActive } = useMessagedAsyncRetry(
    async () => {
      const state = await accountApis.getTwoFactorAuthenticationStatusPut();
      return state;
    },
    [],
    { useProgress: true },
  );

  return (
    <>
      <Card.Ant>
        <Space direction={"vertical"} size={"large"} className={"tw-w-full"}>
          <Space className={"tw-w-full"} direction={"vertical"}>
            <SafetyOutlined width={16} />
            <Typography.Title level={5} className={"!tw-m-0 tw-w-full"}>
              {t("user.2fa.loginTwoStepPassword")}
            </Typography.Title>
          </Space>
          {isTwoFAActive ? (
            <Button
              onClick={() => {
                navigate(profile.m2fa.loginDisable.url);
              }}
              loading={loadingIsTwoFAActive}
            >
              <Space>
                <UnlockOutlined width={14} className={"color--danger"} />
                <Typography.Text className={"color--danger"}>{t("common.deactivate")}</Typography.Text>
              </Space>
            </Button>
          ) : (
            <Button
              onClick={async () => {
                navigate(profile.m2fa.loginEnable.url);
              }}
              loading={loadingIsTwoFAActive}
            >
              <Space>
                <LockOutlined width={14} />
                {t("common.activate")}
              </Space>
            </Button>
          )}
        </Space>
      </Card.Ant>
    </>
  );
};

export default MobileLoginEnableDisable;
